<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h6 class="mb-2">
        {{
          Object.entries(this.data).length === 0
            ? "Adicionar Novo"
            : "Atualizar"
        }}
        PRODUTO
      </h6>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- Product Image -->
        <template v-if="dataImg">
          <!-- Image Container -->
          <div
            class="img-container w-64 mx-auto flex items-center justify-center"
          >
            <img :src="dataImg" alt="img" class="responsive" />
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input
              type="file"
              class="hidden"
              ref="attachFile"
              @change="attachFile"
              accept="image/png, image/gif, image/jpeg, image/jpg"
              name="image"
            />
            <vs-button
              class="mr-4"
              type="flat"
              @click="$refs.attachFile.click()"
              >Trocar Foto</vs-button
            >
            <vs-button type="flat" color="#999" @click="dataImg = null"
              >Remover Foto</vs-button
            >
          </div>
        </template>

        <!-- NAME -->
        <h6 class="mb-2">Nome</h6>
        <vs-input
          v-model="name"
          class="w-full"
          name="nameProduct"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('nameProduct')">{{
          errors.first("nameProduct")
        }}</span>
        <br />
        <!-- PRODUCT CODE -->
        <h6 class="mb-2">Código do Produto</h6>
        <vs-input
          v-model="code"
          class="w-full"
          name="code"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('code')">{{
          errors.first("code")
        }}</span>
        <br />
        <h6 class="mb-2">Categoria</h6>
        <v-select
          name="category"
          v-model="dataCategory"
          :options="optionsCategory"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('category')">{{
          errors.first("category")
        }}</span>
        <br />
        <h6 class="mb-2">Marca</h6>
        <v-select
          name="trademark"
          v-model="dataTrademark"
          :options="optionsTrademark"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('category')">{{
          errors.first("trademark")
        }}</span>
        <br />
        <h6 class="mb-2">Modelo</h6>
        <vs-input
          v-model="model"
          class="w-full"
          name="model"
          v-validate="'required'"
        />
        <br />
        <h6 class="mb-2">Quantidade</h6>

        <vs-input-number v-model="amount" class="mt-5 w-full" name="amount" />
        <br />
        <h6 class="mb-2">Preço</h6>
        <vs-input
          v-model="price"
          class="w-full"
          name="price"
          v-currency="{ currency: 'BRL', locale: 'pt-br' }"
        />
        <span class="text-danger text-sm" v-show="errors.has('model')">{{
          errors.first("model")
        }}</span>

        <div class="upload-img mt-5" v-if="!dataImg">
          <input
            type="file"
            class="hidden"
            ref="attachFile"
            @change="attachFile"
            accept="image/*"
          />
          <vs-button @click="$refs.attachFile.click()">Upload Foto</vs-button>
        </div>
        <span class="text-danger text-sm" v-show="errors.has('file')">{{
          errors.first("file")
        }}</span>
        <!-- Upload DEMO
                            <vs-upload
                          text="Upload Image"
                          class="img-upload"
                          ref="fileUpload"
                          single-upload
                          @on-success="successUpload"
                            @change="handleFileUpload"
                        />
        <vs-button class="mr-6" @click="test()">Submit</vs-button>-->
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button
        class="mr-6"
        @click="submitData()"
        type="filled"
        color="success"
        :disabled="!isFormValid"
        icon-pack="feather"
        icon="icon-save"
        >Salvar</vs-button
      >
      <vs-button
        type="filled"
        color="danger"
        @click="isSidebarActiveLocal = false"
        icon-pack="feather"
        icon="icon-x"
        >Cancelar</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import { fileTools } from "@/helpers";
import axios from "axios";
import { baseApiUrl } from "@/global";
const dict = {
  custom: {
    nameProduct: {
      required: "Por favor insira nome do Produto",
      alpha: "Your first name may only contain alphabetic characters",
    },
    code: {
      required: "Por favor insira o código do Produto",
      alpha: "Your first name may only contain alphabetic characters",
    },
    category: {
      required: "Por favor insira a categoria",
      alpha: "Your first name may only contain alphabetic characters",
    },
    trademark: {
      required: "Por favor insira a marca",
      alpha: "Your first name may only contain alphabetic characters",
    },
    model: {
      required: "Por favor insira o modelo",
      alpha: "Your first name may only contain alphabetic characters",
    },
    file: {
      required: "Por favor insira a imagem",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};
Validator.localize("en", dict);
export default {
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        this.name = this.data.name;
        this.dataImg = this.data.photoProduct;
        this.photoUrl = this.data.photoProduct;
        this.code = this.data.code;
        this.dataCategory = this.data.category;
        this.dataTrademark = {
            id:  this.data.fk_idTrademark,
            label: this.data.trademarkName,
            name:  this.data.trademarkName,
        }
        this.model = this.data.model;
        this.amount = this.data.amount;
        this.price = this.data.price;
        this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },
  data() {
    return {
      fileTools: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      product: {},
      name: "",
      code: "",
      dataImg: null,
      dataCategory: null,
      dataTrademark: null,
      model: "",
      amount: "",
      price: "",
      settings: {
        // perfectscrollbar settings i
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      optionsCategory: ["EQUIPAMENTOS", "SUPRIMENTOS", "PEÇAS", "SERVIÇOS"],
      optionsTrademark: [],
      file: null,
      fileName: null,
      photoUrl: null,
      changedPhoto: false,
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        !this.errors.any() &&
        this.name &&
        this.code &&
        this.dataCategory &&
        this.dataTrademark &&
        this.dataImg
      );
    },
  },
  methods: {
    initValues() {
      if (this.data.idProduct) return;
      this.name = "";
      this.code = "";
      this.dataImg = null;
      this.dataCategory = null;
      this.dataTrademark = null;
      this.model = "";
      this.file = null;
      this.amount = "";
      this.price = "";
      this.fileName = null;
      this.photoUrl = null;
    },
    async submitData() {
      let result = this.$validator.validateAll();
      this.name = this.name ? this.name.toUpperCase() : this.name;
      this.code = this.code ? this.code.toUpperCase() : this.code;
      this.model = this.model ? this.model.toUpperCase() : this.model;
      if (result) {
        this.product = {
          idProduct: this.data.idProduct,
          name: this.name.trim(),
          photoProduct: this.dataImg,
          fileName: this.fileName,
          code: this.code.trim(),
          category: this.dataCategory,
          fk_idTrademark: this.dataTrademark.id,
          trademarkName: this.dataTrademark.name,
          model: this.model.trim(),
          amount: this.amount,
          price: this.price,
          fk_idUser: this.$store.state.user.idUser,
          photo: this.$store.state.avatar,
          photoUrl: this.photoUrl,
          changedPhoto: this.changedPhoto,
        };
        let payload = {
          product: this.product,
          notify: this.$vs.notify,
        };
        if (this.data.idProduct !== null && this.data.idProduct >= 0) {
          this.$store.dispatch("updateProduct", payload);
        } else {
          delete this.product.idProduct;
          this.$store.dispatch("addNewProduct", payload);
        }
        this.changedPhoto = false;
        this.$emit("closeSidebar");
        this.initValues();
      }
    },
    /*
      handleFileUpload() {
      console.log(this.$refs.fileUpload.filesx[0])
      this.file1 = this.$refs.fileUpload.filesx[0];
      
    },
    */
    async getAllTrademark() {
      this.$vs.loading();
      try {
        const response = await axios.get(
          `${baseApiUrl}/trademark/getAllTrademark`
        );
        for (let trademark of response.data) {
          let obj = {
            id: trademark.idTrademark,
            label:trademark.name,
            name: trademark.name,
          };
          this.optionsTrademark.push(obj);
        }
      } catch (error) {
        console.log(error);
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Ocorreu algum problema",
          text: error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async attachFile(event) {
      const attachment = event.target.files;
      if (!attachment.length) return;
      this.dataImg = await this.fileTools.toBase64(attachment[0]);
      this.fileName = attachment[0].name;
      this.changedPhoto = true;
    },
  },
  async created() {
    this.fileTools = fileTools();
    await this.getAllTrademark();
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }
  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload {
      margin-top: 2rem;
      .con-img-upload {
        padding: 0;
      }
      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}
.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>